export default __webpack_public_path__ + "static/media/usfb_logo.919feaeb.png";